import LayerParserBlis from "./ol-geodok/parser/LayerParserBlis"

import VectorLayer from "ol/layer/Vector";
import VectorSource from "ol/source/Vector";
import Group from "ol/layer/Group";
import config from "./config"
import style from "./styles"

let layersMap = {};
let layers = [];
var contextPath = config.getContextPath();

var layerParser = new LayerParserBlis()



var baseLayers = new Group()
layersMap["baseLayers"]=baseLayers;
layers.push(baseLayers)

var overlays = new Group()
layersMap["overlays"]=overlays;
layers.push(overlays)

var customLayers = layerParser.parse(config.getCustomLayers());
customLayers.forEach((layer) => {
    if(layer.get("baseLayer")) {
       baseLayers.getLayers().push(layer);
    }else {
       overlays.getLayers().push(layer);
    }
})

var searchResultLayer = new VectorLayer({
    source: new VectorSource(),
    style: style.twoColorStyle('blue','red') 
});
layersMap["searchResultLayer"]=searchResultLayer;

var highliteLayer = new VectorLayer({
    source: new VectorSource(),
    style: style.highliteStyle() 
});
layersMap["highliteLayer"]=highliteLayer;

var selectLayer = new VectorLayer({
    source: new VectorSource(),
    style: style.selectParcelStyle() 
});
layersMap["selectLayer"]=selectLayer;

var interactivLayerGroup = new Group({layers:[searchResultLayer,highliteLayer,selectLayer]})
layersMap["interactivLayerGroup"]=interactivLayerGroup;
layers.push(interactivLayerGroup)

layersMap["layers"]=layers;
export default layersMap